import { Navigate, type RouteObject } from "react-router-dom"
import ActivitiesPage from "@/pages/activities"
import DiagnosticPage from "@/pages/activities/diagnostic"
import DiagnosticIdPage from "@/pages/activities/diagnostic/id"
import FlashcardsPage from "@/pages/activities/flashcards"
import FlashcardIdPage from "@/pages/activities/flashcards/id"
import ActivityNotFoundPage from "@/pages/activities/activity-not-found"
import ChallengePage from "@/pages/activities/challenge"
import ChallengeIdPage from "@/pages/activities/challenge/id"
import LessonPage from "@/pages/activities/lessons/id"
import LessonsSummaryPage from "@/pages/activities/lessons/summary"

const routes: RouteObject = {
  path: "activities",
  element: <ActivitiesPage />,
  children: [
    {
      path: "flashcards",
      element: <FlashcardsPage />,
      children: [
        {
          path: ":id",
          element: <FlashcardIdPage />,
        },
        {
          path: "notFound",
          element: <ActivityNotFoundPage />,
        },
      ],
    },
    {
      path: "diagnostic",
      element: <DiagnosticPage />,
      children: [
        {
          path: ":id",
          element: <DiagnosticIdPage />,
        },
        {
          path: "notFound",
          element: <ActivityNotFoundPage />,
        },
      ],
    },
    {
      path: "challenge",
      element: <ChallengePage />,
      children: [
        {
          path: ":id",
          element: <ChallengeIdPage />,
        },
        {
          path: "notFound",
          element: <ActivityNotFoundPage />,
        },
      ],
    },
    {
      path: "lessons",
      children: [
        {
          path: ":id",
          element: <LessonPage />,
        },
        {
          path: ":id/summary",
          element: <LessonsSummaryPage />,
        },
        {
          path: "notFound",
          element: <ActivityNotFoundPage />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="activities" replace />,
    },
  ],
}

export default routes
